import Button from 'components/Form/Button';
import React, { useEffect } from 'react';
import MenuEllipse from '../../assets/MenuEllipse.png';
import { Icon, Icons } from 'components/Icon';
import IWillType from 'components/IWillType';
import HowItWorkTextAnimate from 'components/HowItWorkTextAnimate';
import HowItWorkImageAnimate from 'components/HowItWorkImageAnimate';
import family from '../../assets/family.png';
import IWillReview from 'components/IWillReview';
import { Link } from 'react-router-dom';
import { selectAccountDetails } from 'selectors/account-selector';
import { useAppSelector } from 'store/hooks';
import { toast } from 'react-toastify';
import { Alert } from 'components/Toast';
import PlanDesktop from './PlanDesktop';
import PlanMobile from './PlanMobile';
import { Carousel } from 'flowbite-react';
import CarouselItem from 'components/Carousel/CarouselItem';

import UserImage1 from '../../assets/user-image-1.png';
import UserImage2 from '../../assets/user-image-2.png';
import UserImage3 from '../../assets/user-image-3.png';
import UserImage4 from '../../assets/user-image-4.png';
import { useGetPlans } from 'common/queries-and-mutations/payment';

export default function Landing() {
  const { error: loginError } = useAppSelector(selectAccountDetails);

  const { data: plans } = useGetPlans();

  useEffect(() => {
    if (loginError) {
      toast(<Alert message={loginError} type="error" />);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginError]);

  return (
    <>
      {/* Banner */}
      <div className="relative bg-[#F7F6F6]">
        <div className="relative mt-32 flex flex-row justify-between py-10 md:mt-44 md:py-0">
          <div className="pl-20 md:pl-28">
            <h2 className="mb-5 text-[30px] font-medium text-[#121638] md:w-[63%] md:text-3xl lg:w-[55%] lg:text-6xl">
              We made Will Writing so easy, you’d write one in 10 minutes.
            </h2>
            <span className="font-normal text-[#353535] md:text-2xl">
              Dont just take our word for it. Try it for yourself
            </span>
            <Link to="/get-started">
              <Button
                variant="primary"
                size="md"
                className="mt-10 w-[11rem] rounded p-[0.1rem]"
                label="Get Started"
              ></Button>
            </Link>
          </div>
          <div className="hidden md:block">
            <div className="absolute bottom-0 right-[4rem] pt-32 md:bottom-[4rem] md:right-[10rem] md:h-[30rem] md:pt-0 ">
              <div className="w-[12rem] rounded bg-white shadow-2xl md:w-[15rem] lg:w-[22rem]">
                <div className="absolute w-full rounded-t bg-[#F15A24] p-10 text-center text-white md:p-20"></div>
                <div className="relative w-full">
                  <div className="relative h-56 overflow-hidden rounded-lg md:h-96">
                    <Carousel
                      pauseOnHover={true}
                      slideInterval={2000}
                      leftControl={<></>}
                      rightControl={<></>}
                      indicators={false}
                    >
                      <CarouselItem
                        image={UserImage1}
                        title="Ibukun Adeyeye"
                        content="Ibukun was able to complete her education because her Dad
                    made an education trust for her."
                      />
                      <CarouselItem
                        image={UserImage2}
                        title="Niyi Foundation"
                        content="These children will have a better tomorrow thanks to the support of Niyi Foundation."
                      />
                      <CarouselItem
                        image={UserImage3}
                        title="Daniel James"
                        content="Business is booming because Daniel recieved the support and capital he needed to succeed."
                      />
                      <CarouselItem
                        image={UserImage4}
                        title="Sandra Adebayo"
                        content="Sandra was able to complete her education because her Dad made an education trust for her."
                      />
                    </Carousel>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            src={MenuEllipse}
            className="w-[20%] object-fill md:w-[30%] lg:w-[40%]"
          />
        </div>
        <div className="absolute -bottom-9 right-[4rem]">
          <button className="rounded-full bg-white p-6 shadow-2xl">
            <Icon name={Icons.Chat} />
          </button>
        </div>
      </div>

      {/* Plan Type */}
      <div className="mt-10 flex flex-col items-center justify-center bg-white px-10 md:mt-40">
        <h2 className="text-center font-circular text-[1.5rem] font-normal text-[#1E063E] md:w-[40rem] md:leading-[3.5rem] lg:text-[3rem]">
          Made for the every-day Nigerian by legal experts
        </h2>
        <p className="mt-4 font-inter text-sm font-normal text-[#353535] md:text-xl">
          What’s better than one? 4 plan categories to pick from
        </p>

        <div
          className="my-20 grid grid-cols-1 gap-5 overflow-x-auto scrollbar-hide md:grid-cols-2 xl:grid-cols-4 "
          style={{ scrollbarWidth: 'none' }}
        >
          {(plans ?? []).map(plan => (
            <div key={plan.planId}>
              <IWillType
                iWillLogo={plan.image}
                iWillPlan={plan.planType}
                iWillContent={plan.planDesc}
                iWillPlanId={plan.planId}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Plan */}

      <PlanDesktop />
      <PlanMobile />

      {/* How it work */}
      <div className="my-20 bg-[#F7F6F6] md:p-10 lg:p-20">
        <div className="flex flex-col items-center">
          <p className="mt-10 font-circular text-2xl font-normal text-[#1E063E] md:mt-0 md:text-[55px]">
            How it Works
          </p>
        </div>
        <div className="flex gap-10 bg-[#F7F6F6] px-5 py-10 sm:justify-center">
          <div className="hiddens relative w-1/2 md:block">
            <HowItWorkImageAnimate />
          </div>
          <HowItWorkTextAnimate />
        </div>
      </div>
      {/* Family */}
      <div className="bg-white px-36 py-20">
        <div className="flex items-center justify-between ">
          <div className="w-[34rem]">
            <p className="font-circular text-[2.7rem] font-bold text-[#1E063E]">
              I&apos;m just an everyday- person. Do I need a will?
            </p>
            <p className="mt-10 font-circular text-lg font-normal text-[#1E063E]">
              It doesn&apos;t matter if you&apos;re young or old, rich or poor,
              healthy or sick - every parent can benefit from the security of a
              will. Our easy will allows you to make important decisions, like
              naming a guardian for your little ones. If parents know best,
              doesn&apos;t it make sense to put your wisdom in writing? Learn
              more{' '}
              <a
                className="text-base font-bold text-[#000000] underline"
                href=""
              >
                here
              </a>
            </p>
          </div>
          <img src={family} className="w-[35%]" />
        </div>
        <Link to="/get-started">
          <Button
            variant="primary"
            size="md"
            className="mt-5 w-[20rem] rounded p-[1rem] text-2xl"
            label="Start With My WIll Now"
          ></Button>
        </Link>
      </div>

      {/* Will Stories */}
      <div className="mt-20 bg-[#F7F6F6] px-36 py-20">
        <div className="flex flex-col items-center">
          <p className="text-4xl font-bold text-[#1E063E]">
            They Trusted Us to Secure Their Legacy
          </p>
          <p className="text-base font-normal text-[#1E063E]">
            What about you?
          </p>
        </div>
        <div className="mt-20">
          <div className="flex items-center justify-between">
            <div className="w-[34.5rem]">
              <p className="text-4xl font-semibold text-[#1E063E]">
                Over 1500 Wills Written
              </p>
              <p className="mt-10 text-lg font-normal text-[#1E063E]">
                With our expert guidance, and simplified processes, we&apos;ve
                helped countless individuals and families write legally binding
                wills ensuring security, privacy, peace of mind, and ultimately
                a protected future. Also, our user-friendly platform makes it
                easy to organize all your assets making sure you don’t lose
                track of anything you own.
              </p>
              <Link to="/get-started">
                <Button
                  variant="primary"
                  size="md"
                  className="mt-10 w-[15rem] rounded p-[0.5rem] text-2xl font-normal"
                  label="Get started"
                ></Button>
              </Link>
            </div>
            <IWillReview />
          </div>
        </div>
      </div>
    </>
  );
}
